import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PALoans from './PALoans';
import PAOpps from './PAOpps';


const LoansPreApproved = ( { settings } ) => {
    const [ pageType, setPageType ] = useState( 'opps' );

    useEffect( () => {
        if ( settings?.preapprovals?.pageType === 'loans' ) {
            setPageType( 'loans' );
        }
        console.log( 'PA Page Type: ', settings?.preapprovals?.pageType );
    }, [ settings ] );
    
    return (
        <>
            { pageType === 'loans' ? <PALoans /> : <PAOpps /> }
        </>
    )
}

const mapProps = ( state ) => ( {
    settings: state.user.meta.settings
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( LoansPreApproved );